// Auto-generated by build_v2_schemas.py — do not edit manually
import hfpV2ExecutiveFunction from './hfpV2ExecutiveFunction.json';
import hfpV2MotorPhysical from './hfpV2MotorPhysical.json';
import hfpV2SpeechLanguageCommunication from './hfpV2SpeechLanguageCommunication.json';
import hfpV2SocialEmotional from './hfpV2SocialEmotional.json';
import hfpV2Sensory from './hfpV2Sensory.json';
import hfpV2GlobalParticipation from './hfpV2GlobalParticipation.json';
import hfpV2EnvironmentalFactors from './hfpV2EnvironmentalFactors.json';

export const HFP_V2_SCHEMAS = {
  hfpV2ExecutiveFunction,
  hfpV2MotorPhysical,
  hfpV2SpeechLanguageCommunication,
  hfpV2SocialEmotional,
  hfpV2Sensory,
  hfpV2GlobalParticipation,
  hfpV2EnvironmentalFactors,
};

export const HFP_V2_FORM_KEYS = [
  'hfpV2ExecutiveFunction',
  'hfpV2MotorPhysical',
  'hfpV2SpeechLanguageCommunication',
  'hfpV2SocialEmotional',
  'hfpV2Sensory',
  'hfpV2GlobalParticipation',
  'hfpV2EnvironmentalFactors',
];

export const HFP_V2_SCHEMAS_LIST = [
  hfpV2ExecutiveFunction,
  hfpV2MotorPhysical,
  hfpV2SpeechLanguageCommunication,
  hfpV2SocialEmotional,
  hfpV2Sensory,
  hfpV2GlobalParticipation,
  hfpV2EnvironmentalFactors,
];
